import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-cbd49cc0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "sel-main"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 用户基本信息 ");

const _hoisted_4 = ["src"];

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 用户生物特征 ");

const _hoisted_6 = ["src"];

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 用户网络身份标识和鉴权信息 ");

const _hoisted_8 = ["src"];

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 支付数据 ");

const _hoisted_10 = ["src"];

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 位置信息 ");

const _hoisted_12 = ["src"];

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 设备属性信息 ");

const _hoisted_14 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_title = _resolveComponent("top-title");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_top_title, {
    onBack: $setup.back,
    title: "个人信息收集清单"
  }, null, 8, ["onBack"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[0] || (_cache[0] = $event => $setup.router.push({
      'name': 'CollectUserInfo'
    }))
  }, [_hoisted_3, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_4)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[1] || (_cache[1] = $event => $setup.router.push({
      'name': 'CollectUserFace'
    }))
  }, [_hoisted_5, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_6)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[2] || (_cache[2] = $event => $setup.router.push({
      'name': 'CollectUserAuth'
    }))
  }, [_hoisted_7, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_8)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[3] || (_cache[3] = $event => $setup.router.push({
      'name': 'CollectUserPay'
    }))
  }, [_hoisted_9, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_10)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[4] || (_cache[4] = $event => $setup.router.push({
      'name': 'CollectUserLocation'
    }))
  }, [_hoisted_11, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_12)]), _createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[5] || (_cache[5] = $event => $setup.router.push({
      'name': 'CollectUserDevice'
    }))
  }, [_hoisted_13, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_14)])])]);
}